import { CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import AppRoutes from 'AppRoutes';
import { SubscriptionProvider } from 'AppRoutes/context/SubscriptionContext';
import { AuthProvider } from 'services/auth/authContext';
import { CartProvider } from 'services/cart/CartContext';
import { GrowlerCartProvider } from 'services/cart/GrowlerCartContext';

// import App from './App';
// import reportWebVitals from './reportWebVitals';

import theme from './ThemeProvider/theme'; // Import your custom theme

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <SubscriptionProvider>
          <CartProvider>
            <GrowlerCartProvider>
              <AppRoutes />
            </GrowlerCartProvider>
          </CartProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
